// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* { margin: 0; padding: 0; box-sizing: border-box; }

:root {
  --bg: #f8f9fb;
  --sidebar: #1a1d23;
  --sidebar-hover: #2a2d35;
  --accent: #4f8cff;
  --accent-light: #e8f0ff;
  --text: #1a1d23;
  --text-secondary: #6b7280;
  --border: #e5e7eb;
  --card: #ffffff;
  --radius: 10px;
}

body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; background: var(--bg); color: var(--text); }
.app { display: flex; min-height: 100vh; }

/* ── Top navigation bar ── */
/* Fixed-viewport shell: the window itself never scrolls — pages that
   overflow scroll inside .content--topnav instead. */
.app--topnav { flex-direction: column; height: 100vh; min-height: 0; overflow: hidden; }
.topbar {
  background: #f1f5f9;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  padding: 0 18px;
  display: flex;
  align-items: center;
  height: 48px;
  flex-shrink: 0;
}
.topbar-tabs {
  display: flex;
  gap: 8px;
  height: 100%;
  align-items: center;
}
.topbar-link {
  color: #64748b;
  text-decoration: none;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 10px;
  transition: all 0.15s ease;
  letter-spacing: 0.2px;
}
.topbar-link:hover {
  color: #1e293b;
  background: #e2e8f0;
  border-color: #cbd5e1;
}
.topbar-link.active {
  color: #1d4ed8;
  font-weight: 600;
  background: #ffffff;
  border-color: #93c5fd;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

/* Content */
.content { flex: 1 1; padding: 28px 32px; max-width: 1480px; }
.content--topnav { padding: 16px 24px; max-width: none; position: relative; min-height: 0; overflow-y: auto; }

/* Keep the Explorer mounted but hidden when another tab is active. Crucially
   the hidden state must NOT collapse the element's box to 0×0 (that would make
   ForceGraph2D reset its zoom transform on the way back). Absolute + inset:0
   keeps the same width/height as the visible state; visibility:hidden keeps
   layout boxes (so clientWidth/Height stay valid) while hiding paint. */
.explorer-keepalive { display: block; height: 100%; }
.explorer-keepalive.hidden {
  position: absolute;
  inset: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: -1;
}

/* Page header */
.page-header { margin-bottom: 20px; }
.page-header h1 { font-size: 20px; font-weight: 700; }

/* Cards */
.card { background: var(--card); border-radius: var(--radius); border: 1px solid var(--border); padding: 20px; }
.card h3 { font-size: 12px; color: var(--text-secondary); font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 12px; }

/* Tabs */
.tabs { display: flex; gap: 0; margin-bottom: 20px; border-bottom: 2px solid var(--border); }
.tab { padding: 10px 20px; font-size: 13px; font-weight: 500; color: var(--text-secondary); cursor: pointer; border: none; border-bottom: 2px solid transparent; margin-bottom: -2px; background: none; transition: all 0.15s; }
.tab:hover { color: var(--text); }
.tab.active { color: var(--accent); border-bottom-color: var(--accent); font-weight: 500; }

/* Tables */
.table-wrap { overflow-x: auto; }
table { width: 100%; border-collapse: collapse; font-size: 13px; }
table.wide-table { min-width: 1400px; }
th { text-align: left; padding: 8px 12px; border-bottom: 2px solid var(--border); color: var(--text-secondary); font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px; white-space: nowrap; }
td { padding: 8px 12px; border-bottom: 1px solid var(--border); }
tr:hover { background: var(--accent-light); }
td a { color: var(--accent); text-decoration: none; font-weight: 500; }
td a:hover { text-decoration: underline; }
.cell-truncate { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* Pagination */
.pagination { display: flex; gap: 8px; margin-top: 12px; align-items: center; justify-content: center; }
.pagination {
  display: flex;
  gap: 12px;
  margin-top: 0;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}
.pagination button {
  min-width: 88px;
  padding: 7px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  font-size: 12px;
  line-height: 1.2;
  color: #1f2937;
  transition: all 0.15s ease;
}
.pagination button:hover:not(:disabled) {
  border-color: #93c5fd;
  background: #eff6ff;
  color: #1d4ed8;
}
.pagination button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  background: #f8fafc;
}
.pagination span {
  font-size: 12px;
  color: #64748b;
  min-width: 84px;
  text-align: center;
}
.pagination-jump {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
}
.pagination-jump-label {
  font-size: 12px;
  color: #64748b;
}
.pagination-jump-input {
  width: 64px;
  padding: 7px 8px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #0f172a;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
}
.pagination-jump-input:focus {
  outline: none;
  border-color: #93c5fd;
  box-shadow: 0 0 0 2px rgba(147, 197, 253, 0.3);
}
.pagination-jump-btn {
  min-width: 52px;
  padding: 7px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  color: #1f2937;
  font-size: 12px;
  line-height: 1.2;
  cursor: pointer;
  transition: all 0.15s ease;
}
.pagination-jump-btn:hover {
  border-color: #93c5fd;
  background: #eff6ff;
  color: #1d4ed8;
}

/* Description box */
.desc-box { background: #f9fafb; padding: 16px; border-radius: 8px; font-size: 13px; line-height: 1.6; color: #374151; margin-bottom: 20px; }

/* Error / Loading */
.error { background: #fef2f2; color: #dc2626; padding: 12px 16px; border-radius: 8px; margin-bottom: 16px; font-size: 13px; }
.loading { text-align: center; padding: 40px; color: var(--text-secondary); }

/* Buttons */
.btn { padding: 10px 24px; background: var(--accent); color: #fff; border: none; border-radius: 8px; font-size: 14px; font-weight: 600; cursor: pointer; white-space: nowrap; }
.btn:hover { background: #3b7aef; }
.btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* NL → SQL */
.nl-section { margin-bottom: 20px; }
.toggle-btn { background: none; border: none; font-size: 14px; font-weight: 600; color: var(--text-secondary); cursor: pointer; padding: 8px 0; }
.toggle-btn:hover { color: var(--text); }
.nl-body { margin-top: 8px; }
.nl-input-row { display: flex; gap: 12px; margin-bottom: 12px; }
.nl-input-row input { flex: 1 1; padding: 10px 14px; border: 1px solid var(--border); border-radius: 8px; font-size: 14px; }
.nl-input-row input:focus { outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px rgba(79,140,255,0.1); }
.example-chips { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 8px; }
.chip { padding: 5px 12px; font-size: 12px; border: 1px solid var(--border); border-radius: 16px; background: white; cursor: pointer; color: var(--text-secondary); }
.chip:hover { border-color: var(--accent); color: var(--accent); }

/* SQL section */
.sql-section { margin-bottom: 16px; }
.sql-editor-section { margin-bottom: 20px; }
.sql-label { display: block; font-size: 12px; font-weight: 600; color: var(--text-secondary); text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 6px; }
.sql-editor { width: 100%; padding: 14px 16px; border: 1px solid var(--border); border-radius: 8px; font-family: 'SF Mono', 'Fira Code', monospace; font-size: 13px; line-height: 1.6; resize: vertical; background: #1a1d23; color: #e2e8f0; }
.sql-editor:focus { outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px rgba(79,140,255,0.1); }
.sql-editor::placeholder { color: #555; }
.sql-actions { display: flex; align-items: center; gap: 12px; margin-top: 8px; }
.hint { font-size: 12px; color: var(--text-secondary); }
.result-card { margin-top: 4px; }

/* View buttons (reusable) */
.view-btn { padding: 8px 20px; font-size: 13px; font-weight: 600; border: 1px solid var(--border); border-radius: 8px; background: var(--card); color: var(--text-secondary); cursor: pointer; transition: all 0.15s; }
.view-btn:hover { border-color: var(--accent); color: var(--accent); }
.view-btn.active { background: var(--accent); color: #fff; border-color: var(--accent); }

/* Query result blocks */
.query-block { margin-top: 20px; }
.query-block-header { display: flex; align-items: center; gap: 12px; margin-bottom: 8px; }
.query-block-label { font-size: 13px; font-weight: 700; color: var(--text); text-transform: uppercase; letter-spacing: 0.5px; }
.code-toggles { display: none; }

/* ── Badges ── */
.badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
}
.badge-ai { background: #dbeafe; color: #1d4ed8; }
.badge-non-ai { background: #f3f4f6; color: #6b7280; }
.badge-threat-1 { background: #fecaca; color: #991b1b; }
.badge-threat-2 { background: #fef3c7; color: #92400e; }
.badge-threat-3 { background: #d1fae5; color: #065f46; }
.badge-threat-4 { background: #f3f4f6; color: #6b7280; }

/* (old graph-and-panel removed — unified layout now) */

/* ── Ontology layout: graph left, table slides in from right ── */
.explorer-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.explorer-view-switch {
  display: flex;
  align-items: center;
  gap: 8px;
}
.kg-placeholder {
  min-height: calc(100vh - 132px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: var(--text-secondary);
}
.kg-placeholder h3 {
  color: var(--text);
  margin-bottom: 8px;
}
.kg-placeholder p {
  max-width: 680px;
  line-height: 1.6;
}
.kg-placeholder-muted {
  margin-top: 8px;
  font-size: 13px;
}
.kg-status-box {
  margin: 16px 0;
  padding: 14px 16px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #f8fafc;
  text-align: left;
  min-width: 420px;
  font-size: 13px;
  line-height: 1.7;
}
.kg-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  min-height: 0;
}
.kg-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 12px;
  flex: 1 1;
  min-height: 0;
}
.kg-graph-shell {
  padding: 0;
  overflow: hidden;
  min-height: 0;
}
.kg-canvas-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  background: #f8fafc;
  background-image: radial-gradient(rgba(15, 23, 42, 0.05) 1px, transparent 1px);
  background-size: 22px 22px;
  border: 1px solid var(--border);
  border-radius: 8px;
}
.kg-overlay {
  position: absolute;
  z-index: 4;
  pointer-events: none;
}
.kg-overlay > * {
  pointer-events: auto;
}
.kg-overlay-top {
  top: 12px;
  left: 12px;
  right: 12px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 10px;
}
.kg-overlay-bottom {
  bottom: 12px;
  left: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.kg-search-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 200px;
  max-width: 280px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(4px);
}
.kg-search-icon {
  color: #64748b;
  font-size: 16px;
}
.kg-search-inline {
  flex: 1 1;
  border: none;
  background: transparent;
  color: #0f172a;
  font-size: 14px;
  outline: none;
  min-width: 0;
}
.kg-search-inline::placeholder {
  color: #94a3b8;
}
.kg-type-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1 1;
  justify-content: center;
}
.kg-type-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  background: rgba(255, 255, 255, 0.88);
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  backdrop-filter: blur(4px);
  transition: border-color 0.15s, background 0.15s, color 0.15s;
}
.kg-type-pill[data-active="true"] {
  border-color: var(--accent);
  background: #ffffff;
  color: #1d4ed8;
  box-shadow: 0 1px 4px rgba(37, 99, 235, 0.2);
}
.kg-type-pill[data-active="false"] {
  opacity: 0.55;
}
.kg-type-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.kg-zoom-stack {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: auto;
}
.kg-zoom-btn {
  width: 32px;
  height: 32px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.92);
  color: #334155;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  backdrop-filter: blur(4px);
}
.kg-zoom-btn[data-active="true"] {
  border-color: var(--accent);
  color: #1d4ed8;
}
.kg-zoom-btn:hover {
  background: #ffffff;
  border-color: rgba(15, 23, 42, 0.2);
}
.kg-legend {
  position: absolute;
  bottom: 52px;
  left: 12px;
  z-index: 4;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(15, 23, 42, 0.1);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(4px);
  pointer-events: none;
}
.kg-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #475569;
  text-transform: capitalize;
}
.kg-legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.kg-summary-dark {
  color: #64748b;
  font-size: 12px;
  margin-left: auto;
}
.kg-action-btn {
  background: rgba(255, 255, 255, 0.92) !important;
  border: 1px solid rgba(15, 23, 42, 0.12) !important;
  color: #334155 !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  backdrop-filter: blur(4px);
}
.kg-empty-dark {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
}
.kg-graph {
  padding: 0;
  overflow: hidden;
  min-height: 0;
}
.kg-detail {
  overflow: auto;
  min-height: 0;
  max-height: 100%;
}
.kg-detail-title {
  font-weight: 700;
  color: var(--text);
  margin-bottom: 4px;
  overflow-wrap: anywhere;
}
.kg-detail-type {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 12px;
}
.kg-detail dl {
  margin: 0;
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr);
  gap: 8px 10px;
  font-size: 12px;
}
.kg-detail dt {
  color: var(--text-secondary);
  font-weight: 600;
}
.kg-detail dd {
  margin: 0;
  overflow-wrap: anywhere;
}
.kg-sources {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
}
.kg-sources-head {
  font-size: 12px;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 8px;
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}
.kg-sources-hint {
  font-weight: 400;
  font-size: 11px;
  color: var(--text-secondary);
}
.kg-sources-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.kg-sources-list li {
  font-size: 12px;
  display: flex;
  align-items: baseline;
  gap: 6px;
  flex-wrap: wrap;
}
.kg-sources-list a {
  color: #2563eb;
  text-decoration: none;
  overflow-wrap: anywhere;
}
.kg-sources-list a:hover {
  text-decoration: underline;
}
.kg-source-via {
  font-size: 10px;
  color: var(--text-secondary);
  background: var(--surface-2, #f1f5f9);
  padding: 1px 6px;
  border-radius: 999px;
  white-space: nowrap;
}
.kg-empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  font-size: 14px;
}
/* Explorer fills the viewport-sized content area exactly — no page scroll. */
.explorer-root {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
/* Holds the ontology view (in flow) and the KG view (overlay) so toggling
   between them never unmounts/resizes either force-graph. */
.explorer-views { position: relative; flex: 1 1; min-height: 0; }
.explorer-kg-layer {
  position: absolute;
  inset: 0;
  background: var(--bg, #f8fafc);
  z-index: 5;
}
.explorer-kg-layer.hidden {
  visibility: hidden;
  pointer-events: none;
}

.ont-split {
  display: flex;
  flex-direction: row;
  gap: 0;
  align-items: stretch;
  height: 100%;
  min-height: 0;
  position: relative;
}
.ont-split-graph {
  flex: 1 1;
  min-width: 0;
  transition: flex 0.3s ease;
  contain: layout paint;
  isolation: isolate;
  border-radius: var(--radius);
}
.ont-split-table {
  flex: 0 0;
  min-width: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: flex-basis 0.3s ease, opacity 0.25s ease;
  opacity: 0;
  pointer-events: none;
}
.ont-split-table.open {
  flex: 0 0 48%;
  opacity: 1;
  pointer-events: auto;
  margin-left: 12px;
}
/* Table-only: hide graph so the data grid uses the full explorer width */
.ont-split--table-full .ont-split-graph {
  display: none;
}
.ont-split--table-full .ont-split-table.open {
  flex: 1 1 100%;
  margin-left: 0;
  min-width: 0;
}
.ont-table-container {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  max-height: 100%;
}
.ont-table-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}
.ont-table-search-wrap {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  width: 200px;
  transition: border-color 0.15s, background 0.15s;
}
.ont-table-search-wrap:focus-within {
  border-color: #93c5fd;
  background: #ffffff;
}
.ont-table-search-icon { color: #94a3b8; font-size: 15px; line-height: 1; }
.ont-table-search {
  flex: 1 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 13px;
  color: #0f172a;
  min-width: 0;
}
.ont-table-search::placeholder { color: #94a3b8; }
.ont-table-empty {
  text-align: center;
  color: #94a3b8;
  padding: 24px 12px !important;
  font-size: 13px;
}
.ont-table-filters-toggle {
  font-size: 12px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid #cbd5e1;
  background: #f8fafc;
  color: #475569;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
}
.ont-table-filters-toggle:hover { border-color: #94a3b8; color: #334155; }
.ont-table-filters-toggle[data-active="true"] {
  border-color: #93c5fd;
  background: #eff6ff;
  color: #1d4ed8;
}
.ont-table-clear-filters {
  font-size: 12px;
  font-weight: 600;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid transparent;
  background: none;
  color: #dc2626;
  cursor: pointer;
}
.ont-table-clear-filters:hover { background: #fef2f2; }
/* Per-column filter row. Higher-specificity selector to override the sticky
   header rule so this row sits directly under the headers (not overlapping). */
.ont-table-scroll thead tr.ont-filter-row th {
  padding: 6px 8px;
  background: #f1f5f9;
  border-bottom: 1px solid var(--border);
  box-shadow: none;
  position: static;
  z-index: 1;
}
.ont-filter-input {
  width: 100%;
  min-width: 70px;
  box-sizing: border-box;
  padding: 4px 8px;
  font-size: 12px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #ffffff;
  color: #0f172a;
  outline: none;
}
.ont-filter-input:focus { border-color: #93c5fd; }
.ont-filter-range {
  display: flex;
  gap: 4px;
}
.ont-filter-range .ont-filter-input { min-width: 0; }
.ont-table-expand {
  font-size: 20px;
  font-weight: 500;
  cursor: pointer;
  color: #475569;
  width: 40px;
  height: 40px;
  padding: 0;
  line-height: 1;
  border-radius: 999px;
  border: 1px solid #cbd5e1;
  background: #f8fafc;
  transition: all 0.15s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.ont-table-expand:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
  color: #334155;
}
.ont-table-expand[data-active="true"] {
  background: #eff6ff;
  border-color: #93c5fd;
  color: #1d4ed8;
}
.ont-table-close {
  margin-left: 0;
  border: none;
  background: none;
  font-size: 18px;
  cursor: pointer;
  color: var(--text-secondary);
  padding: 0 4px;
  line-height: 1;
}
.ont-table-close:hover { color: var(--text); }
.ont-table-class-name {
  font-size: 16px;
  font-weight: 700;
  color: #1d4ed8;
}
.ont-table-count {
  font-size: 12px;
  color: var(--text-secondary);
  background: #f3f4f6;
  padding: 2px 10px;
  border-radius: 12px;
}
.ont-table-kind-badge {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 2px 8px;
  border-radius: 4px;
  background: #dbeafe;
  color: #1d4ed8;
}
.ont-table-kind-badge[data-kind="edge"] {
  background: #dbeafe;
  color: #1d4ed8;
}
.ont-table-scroll {
  flex: 1 1;
  min-height: 0;
  overflow-x: scroll;
  overflow-y: auto;
  padding: 0;
  scrollbar-gutter: stable;
}
.ont-table-scroll::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}
.ont-table-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 6px;
}
.ont-table-scroll::-webkit-scrollbar-thumb {
  background: #93c5fd;
  border-radius: 6px;
  border: 2px solid #f1f5f9;
}
.ont-table-scroll::-webkit-scrollbar-thumb:hover {
  background: #60a5fa;
}
.ont-table-scroll table {
  min-width: max-content;
  width: 100%;
}
.ont-table-scroll thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f8fafc;
  box-shadow: inset 0 -1px 0 #e5e7eb;
}
/* (table empty state removed — panel is hidden when nothing selected) */

/* ── Node Detail Panel ── */
.node-detail-panel {
  width: 300px;
  min-width: 280px;
  max-height: 520px;
  overflow-y: auto;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px;
}
.node-detail-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
.node-detail-class-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.node-detail-label {
  font-weight: 600;
  font-size: 14px;
  flex: 1 1;
  word-break: break-word;
}
.node-detail-close {
  border: none;
  background: none;
  font-size: 18px;
  cursor: pointer;
  color: var(--text-secondary);
  padding: 0 4px;
  line-height: 1;
}
.node-detail-close:hover { color: var(--text); }
.node-detail-section-title {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-secondary);
  margin-bottom: 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--border);
}
.node-detail-props {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.node-detail-row {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.node-detail-key {
  font-size: 10px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.node-detail-val {
  font-size: 13px;
  color: var(--text);
  word-break: break-word;
  line-height: 1.4;
}
.node-detail-empty {
  font-size: 13px;
  color: var(--text-secondary);
  padding: 12px 0;
}
.node-detail-hint {
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px solid var(--border);
  font-size: 11px;
  color: var(--text-secondary);
  line-height: 1.5;
}

/* ── Vuln Detail meta bar ── */
.vuln-meta-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid var(--border);
}
.vuln-meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
}
.vuln-meta-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.vuln-meta-value {
  font-size: 13px;
  color: var(--text);
}

/* ── Reference list ── */
.ref-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.ref-list li {
  padding: 4px 0;
  border-bottom: 1px solid #f3f4f6;
}
.ref-list li:last-child { border-bottom: none; }
.ref-list a {
  color: var(--accent);
  text-decoration: none;
  font-size: 13px;
  word-break: break-all;
}
.ref-list a:hover { text-decoration: underline; }

/* ── Extract Page ── */
.extract-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.extract-input-card h3 {
  margin-bottom: 4px;
}
.extract-subtitle {
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 16px;
  line-height: 1.5;
}
.extract-url-row {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}
.extract-url-input {
  flex: 1 1;
  padding: 10px 14px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 14px;
  font-family: 'SF Mono', 'Fira Code', monospace;
}
.extract-url-input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(79,140,255,0.1);
}
.extract-preview-btn {
  background: #fff !important;
  color: var(--accent) !important;
  border: 1px solid var(--accent) !important;
}
.extract-preview-btn:hover:not(:disabled) {
  background: var(--accent-light) !important;
}
.extract-options {
  margin-bottom: 12px;
}
.extract-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--text-secondary);
  cursor: pointer;
}
.extract-checkbox input[type="checkbox"] {
  accent-color: var(--accent);
}

/* Pipeline steps */
.extract-progress-card {
  padding: 16px 24px;
}
.extract-steps {
  display: flex;
  align-items: center;
  gap: 0;
  justify-content: center;
}
.extract-step {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
}
.extract-step--pending {
  color: #9ca3af;
}
.extract-step--active {
  color: #1d4ed8;
  background: #eff6ff;
}
.extract-step--done {
  color: #059669;
  background: #ecfdf5;
}
.extract-step--error {
  color: #dc2626;
  background: #fef2f2;
}
.extract-step--skipped {
  color: #9ca3af;
  background: #f3f4f6;
}
.extract-step-icon {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
}
.extract-step-divider {
  width: 32px;
  height: 2px;
  background: #e5e7eb;
  margin: 0 4px;
}
.extract-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #93c5fd;
  border-top-color: #1d4ed8;
  border-radius: 50%;
  animation: extract-spin 0.7s linear infinite;
}
@keyframes extract-spin {
  to { transform: rotate(360deg); }
}

/* Stats bar */
.extract-stats-card {
  padding: 16px 24px;
}
.extract-stats-grid {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
}
.extract-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}
.extract-stat-value {
  font-size: 24px;
  font-weight: 700;
  color: var(--accent);
}
.extract-stat-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Markdown preview */
.extract-markdown-preview {
  margin-top: 12px;
  padding: 16px;
  background: #1a1d23;
  color: #e2e8f0;
  border-radius: 8px;
  font-family: 'SF Mono', 'Fira Code', monospace;
  font-size: 12px;
  line-height: 1.6;
  max-height: 400px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
}

/* Vuln list */
.extract-vuln-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
}
.extract-vuln-card {
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
}
.extract-vuln-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: #f8fafc;
  cursor: pointer;
  flex-wrap: wrap;
}
.extract-vuln-header:hover {
  background: #f1f5f9;
}
.extract-vuln-id {
  font-weight: 700;
  font-size: 14px;
}
.extract-vuln-id a {
  color: var(--accent);
  text-decoration: none;
}
.extract-vuln-id a:hover {
  text-decoration: underline;
}
.extract-vuln-title {
  flex: 1 1;
  font-size: 13px;
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.extract-vuln-toggle {
  font-size: 12px;
  color: var(--text-secondary);
}
.extract-vuln-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.extract-vuln-desc {
  font-size: 13px;
  line-height: 1.6;
  color: #374151;
  background: #f9fafb;
  padding: 12px;
  border-radius: 6px;
}
.extract-vuln-meta {
  font-size: 12px;
  color: var(--text-secondary);
}
.extract-vuln-meta-label {
  font-weight: 600;
  color: #475569;
}
.extract-vuln-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.extract-vuln-section-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-secondary);
}
.extract-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.extract-tag {
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background: #fef3c7;
  color: #92400e;
}
.extract-products-table {
  font-size: 12px;
}
.extract-products-table th {
  font-size: 10px;
  padding: 6px 10px;
}
.extract-products-table td {
  padding: 6px 10px;
  font-size: 12px;
}

/* ── Data Sources section (unified with Extract) ── */
.sources-section { margin-top: 18px; }
.sources-header { margin-bottom: 12px; }
.sources-toast {
  padding: 10px 14px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  font-size: 13px;
  margin-bottom: 12px;
  color: #1e3a8a;
}
.sources-list {
  list-style: none;
  padding: 0;
  margin: 0;
  border-top: 1px solid #e5e7eb;
}
.source-row {
  border-bottom: 1px solid #e5e7eb;
}
.source-row-main {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 4px;
  cursor: pointer;
}
.source-row-main:hover { background: #f8fafc; }
.source-row-info { flex: 1 1; min-width: 0; }
.source-row-title {
  display: flex;
  align-items: center;
  gap: 8px;
}
.source-row-chevron {
  color: #94a3b8;
  font-size: 12px;
  width: 14px;
  display: inline-block;
}
.source-row-name {
  font-weight: 600;
  font-size: 15px;
  color: #111827;
}
.source-row-category {
  font-size: 11px;
  color: #64748b;
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 9999px;
}
.source-row-meta {
  margin-top: 4px;
  margin-left: 22px;
  font-size: 12px;
  color: #64748b;
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.btn-primary {
  background: var(--accent) !important;
  color: #fff !important;
  border: none;
  padding: 8px 16px;
  font-size: 13px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  white-space: nowrap;
}
.btn-primary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.source-row-detail {
  padding: 4px 4px 16px 22px;
  background: #fafbfc;
  border-top: 1px solid #f1f5f9;
}
.source-url-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin-top: 10px;
}
.source-url-table th,
.source-url-table td {
  padding: 6px 10px;
  text-align: left;
  border-bottom: 1px solid #f1f5f9;
}
.source-url-table th {
  font-size: 11px;
  color: #475569;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  background: #f8fafc;
}
.source-url-cell {
  word-break: break-all;
  max-width: 500px;
}
.source-runs {
  margin-top: 16px;
}
.source-runs-title {
  font-size: 11px;
  color: #475569;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 6px;
}
.source-runs ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.source-runs li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  font-size: 12px;
  color: #475569;
}
.source-run-url { flex: 1 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.source-run-meta { color: #64748b; }
.source-run-time { color: #94a3b8; font-size: 11px; }

/* ── Live extract status + entity tables ────────────────────────────── */
.extract-results { display: flex; flex-direction: column; gap: 14px; margin-top: 14px; }

.extract-running-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  color: #1e3a8a;
  font-size: 14px;
  margin-bottom: 12px;
}
.extract-running-banner em {
  font-style: normal;
  font-weight: 600;
  color: #1d4ed8;
}

.extract-warnings {
  background: #fffbeb;
  border: 1px solid #fcd34d;
  color: #92400e;
  font-size: 13px;
  padding: 10px 14px;
}
.extract-warnings ul { margin: 6px 0 0; padding-left: 20px; }

.entity-table-card { padding: 14px 18px; }
.entity-table-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
.entity-table-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  text-transform: none;
  letter-spacing: 0;
}
.entity-table-wrap {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
}
.entity-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.entity-table th,
.entity-table td {
  padding: 7px 10px;
  text-align: left;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: top;
  white-space: nowrap;
}
.entity-table th {
  font-size: 10.5px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #475569;
  font-weight: 700;
  background: #f8fafc;
  position: sticky;
  top: 0;
}
.entity-table tbody tr:hover { background: #f8fafc; }
.entity-table tr.row-partial td { background: #fffbeb; }

/* ── Running runs panel ─────────────────────────────────────────────── */
.runs-panel {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f8fafc;
  margin-bottom: 14px;
  overflow: hidden;
}
.runs-panel--active {
  background: #eff6ff;
  border-color: #bfdbfe;
  box-shadow: 0 0 0 1px #bfdbfe40;
}
.runs-panel-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  font-size: 13px;
  color: #1e3a8a;
  border-bottom: 1px solid #e5e7eb;
  background: rgba(255, 255, 255, 0.5);
}
.runs-panel-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 220px;
  overflow-y: auto;
}
.run-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 14px;
  font-size: 12px;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
}
.run-item:last-child { border-bottom: none; }
.run-item--running { background: #fff; }
.run-item--error { background: #fef2f2; }
.run-source {
  font-weight: 600;
  min-width: 120px;
  color: #1e293b;
}
.run-url {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #64748b;
}
.run-meta { color: #64748b; white-space: nowrap; }
.run-elapsed { color: #94a3b8; white-space: nowrap; font-size: 11px; }
.btn-inline {
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 6px;
  line-height: 1.2;
}
.btn-danger {
  background: #ef4444 !important;
  color: #fff !important;
  border: none;
}
.btn-danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ── Source row: running state ──────────────────────────────────────── */
.source-row--running { background: #eff6ff; }
.source-row--running:hover { background: #dbeafe; }
.source-running-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  background: #dbeafe;
  color: #1e3a8a;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  margin-left: 4px;
}
.source-running-chip .extract-spinner {
  width: 10px;
  height: 10px;
  border-width: 1.5px;
}

/* ── Simplified source URL list ─────────────────────────────────────── */
.source-url-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.source-url-list-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  font-size: 13px;
  border-bottom: 1px solid #f1f5f9;
}
.source-url-list-item:last-child { border-bottom: none; }
.source-url-list-item a {
  color: #1d4ed8;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
  min-width: 0;
}
.source-url-list-item a:hover { text-decoration: underline; }
.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* ── Flat URL list (primary UI) ─────────────────────────────────────── */
.urls-section { margin-top: 18px; }
.urls-actions {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  align-items: center;
}
.urls-filter {
  flex: 0 0 180px;
  padding: 8px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 13px;
}
.url-flat-list {
  list-style: none;
  margin: 0;
  padding: 0;
  border-top: 1px solid #f1f5f9;
}
.url-flat-item {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
}
.url-flat-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 6px;
}
.url-flat-row:hover { background: #f8fafc; }
.url-flat-item--open > .url-flat-row {
  background: #f1f5f9;
}
.url-preview {
  padding: 10px 12px 14px;
  background: #f8fafc;
  border-top: 1px dashed #e2e8f0;
}
.url-preview-status {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #475569;
  font-size: 13px;
  padding: 6px 0;
}
.url-preview-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
  color: #0f172a;
  font-size: 13px;
}
.url-preview-actions {
  display: flex;
  gap: 6px;
}
.url-preview .extract-results { margin-top: 4px; }
.url-preview .extract-results .card { box-shadow: none; }

/* ── In-app confirmation modal (replaces window.confirm) ── */
.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
  animation: modal-fade 0.12s ease-out;
}
.modal-card {
  width: min(440px, calc(100vw - 32px));
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.3);
  padding: 20px 22px 16px;
  animation: modal-pop 0.14s ease-out;
}
.modal-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
}
.modal-body {
  font-size: 13px;
  line-height: 1.55;
  color: #475569;
  margin-bottom: 18px;
}
.confirm-mono {
  display: block;
  margin-top: 8px;
  padding: 8px 10px;
  background: #f1f5f9;
  border-radius: 6px;
  font-size: 12px;
  color: #334155;
  word-break: break-all;
}
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
@keyframes modal-fade { from { opacity: 0; } to { opacity: 1; } }
@keyframes modal-pop {
  from { opacity: 0; transform: translateY(6px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

/* ── Consolidation summary (shown after Consolidate) ── */
.consolidate-summary {
  border: 1px solid #bbf7d0;
  background: #f0fdf4;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 12px;
}
.consolidate-head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 13px;
  color: #166534;
  margin-bottom: 10px;
}
.consolidate-head svg { color: #16a34a; }
.consolidate-headline {
  font-size: 13px;
  line-height: 1.5;
  color: #334155;
  margin-bottom: 12px;
}
.consolidate-headline strong { color: #0f172a; }

/* New/updated vulnerability cards — the payoff of consolidation */
.consolidate-vulns {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.vuln-result-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-left: 3px solid #16a34a;
  border-radius: 8px;
  padding: 10px 12px;
}
.vuln-result-top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.vuln-result-id {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 13px;
  font-weight: 700;
  color: #1d4ed8;
  text-decoration: none;
}
.vuln-result-id:hover { text-decoration: underline; }
.vuln-tag {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding: 2px 7px;
  border-radius: 999px;
}
.vuln-tag--new { background: #dcfce7; color: #15803d; }
.vuln-tag--reused { background: #f1f5f9; color: #64748b; }
.vuln-tag--minted { background: #f3e8ff; color: #7c3aed; }
.vuln-result-title {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  margin-top: 5px;
  line-height: 1.4;
}
.vuln-result-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
  margin-top: 6px;
}
.vuln-result-rel { font-size: 12px; color: #334155; }
.vuln-result-rel-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #94a3b8;
  margin-right: 4px;
}
.vuln-result-actions {
  display: flex;
  gap: 8px;
  margin-top: 9px;
}

.consolidate-breakdown-toggle {
  background: none;
  border: none;
  padding: 4px 0;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
}
.consolidate-breakdown-toggle:hover { color: #334155; }
.consolidate-cols {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 8px;
}
.consolidate-col {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 10px;
}
.consolidate-col-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 6px;
  color: #64748b;
}
.consolidate-col--add .consolidate-col-title { color: #15803d; }
.consolidate-col--reuse .consolidate-col-title { color: #1d4ed8; }
.consolidate-col--link .consolidate-col-title { color: #7c3aed; }
.consolidate-col ul { margin: 0; padding: 0; list-style: none; }
.consolidate-col li { font-size: 12px; color: #334155; padding: 2px 0; }
.consolidate-col-empty { font-size: 12px; color: #cbd5e1; }
.consolidate-count {
  display: inline-block;
  min-width: 18px;
  font-weight: 700;
  color: #0f172a;
}
.consolidate-note {
  margin-top: 8px;
  font-size: 12px;
  color: #475569;
}
.consolidate-where {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #d1fae5;
}
.consolidate-where-label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}
.consolidate-link {
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  color: #1d4ed8;
  text-decoration: none;
}
.consolidate-link:hover { border-color: #1d4ed8; background: #eff6ff; }
.consolidate-link--graph { color: #7c3aed; }
.consolidate-link--graph:hover { border-color: #7c3aed; background: #f5f3ff; }
.url-flat-link {
  flex: 1 1;
  min-width: 0;
  color: #1d4ed8;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.url-flat-link:hover { text-decoration: underline; }
.url-flat-entities {
  color: #64748b;
  font-size: 11px;
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 9999px;
  white-space: nowrap;
}
.url-flat-error {
  color: #b91c1c;
  font-size: 11px;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.url-flat-time {
  color: #94a3b8;
  font-size: 11px;
  white-space: nowrap;
}
.btn-ghost {
  background: transparent !important;
  color: #94a3b8 !important;
  border: 1px solid #e5e7eb !important;
}
.btn-ghost:hover {
  color: #ef4444 !important;
  border-color: #fecaca !important;
}

/* Small icon + label buttons used inside the URL list rows. */
.btn-icon {
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
  padding: 4px 10px !important;
  font-size: 12px !important;
  line-height: 1 !important;
  border-radius: 9999px !important;
  white-space: nowrap;
}
.btn-icon svg { display: block; }
.btn-icon.btn-ghost {
  padding: 4px 6px !important;
  color: #94a3b8 !important;
}

/* Smart extract button — variants convey status at a glance. */
.btn-extract {
  border: 1px solid transparent !important;
  transition: background .12s ease, color .12s ease, border-color .12s ease;
}
.btn-extract[disabled] { opacity: .7; cursor: default; }
.btn-extract-icon { display: inline-flex; }
.btn-extract-label { font-weight: 600; letter-spacing: .01em; }

/* never / default → primary action */
.btn-extract--extract {
  background: #4f8cff !important;
  color: #fff !important;
}
.btn-extract--extract:hover:not([disabled]) { background: #3b75ea !important; }

/* fresh → "done" pill, subdued but still actionable (click to re-preview) */
.btn-extract--done {
  background: #ecfdf5 !important;
  color: #047857 !important;
  border-color: #a7f3d0 !important;
}
.btn-extract--done:hover:not([disabled]) {
  background: #d1fae5 !important;
  border-color: #6ee7b7 !important;
}

/* merged → stronger success state than extracted */
.btn-extract--merged {
  background: #dcfce7 !important;
  color: #166534 !important;
  border-color: #86efac !important;
}
.btn-extract--merged:hover:not([disabled]) {
  background: #bbf7d0 !important;
  border-color: #4ade80 !important;
}

/* stale / error → amber/red retry */
.btn-extract--retry {
  background: #fff7ed !important;
  color: #b45309 !important;
  border-color: #fed7aa !important;
}
.btn-extract--retry:hover:not([disabled]) {
  background: #ffedd5 !important;
  border-color: #fdba74 !important;
}

/* open preview → close */
.btn-extract--close {
  background: #f1f5f9 !important;
  color: #475569 !important;
  border-color: #cbd5e1 !important;
}
.btn-extract--close:hover:not([disabled]) {
  background: #e2e8f0 !important;
}

/* running in background */
.btn-extract--running {
  background: #eff6ff !important;
  color: #1d4ed8 !important;
  border-color: #bfdbfe !important;
}

/* ── CISA KEV (Known Exploited Vulnerability) indicators ── */
.badge-kev {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: #7f1d1d;
  color: #fff;
  border: 1px solid #991b1b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.badge-kev::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fca5a5;
  box-shadow: 0 0 0 2px rgba(252, 165, 165, 0.35);
}
.badge-ransomware {
  background: #431407;
  color: #fdba74;
  border: 1px solid #7c2d12;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Full-width advisory banner (vulnerability detail page) */
.kev-banner {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 18px;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #fef2f2 0%, #fff1f2 100%);
  border: 1px solid #fecaca;
  border-left: 4px solid #b91c1c;
  border-radius: 8px;
}
.kev-banner-icon {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #b91c1c;
  color: #fff;
  font-size: 17px;
  font-weight: 700;
}
.kev-banner-body { flex: 1 1; min-width: 0; }
.kev-banner-title {
  font-size: 13px;
  font-weight: 800;
  color: #7f1d1d;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 3px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.kev-banner-text {
  font-size: 13px;
  line-height: 1.55;
  color: #7f1d1d;
}
.kev-banner-meta {
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
  margin-top: 8px;
}
.kev-banner-meta-item { display: flex; flex-direction: column; gap: 1px; }
.kev-banner-meta-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #b91c1c;
}
.kev-banner-meta-value { font-size: 13px; font-weight: 600; color: #450a0a; }
.kev-banner-link {
  font-size: 12px;
  font-weight: 600;
  color: #b91c1c;
  text-decoration: none;
  white-space: nowrap;
  align-self: center;
  padding: 6px 12px;
  border: 1px solid #fca5a5;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
}
.kev-banner-link:hover { background: #fee2e2; border-color: #f87171; }

/* Compact callout (graph detail side panels) */
.kev-callout {
  margin: 0 0 12px;
  padding: 10px 12px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-left: 3px solid #b91c1c;
  border-radius: 6px;
}
.kev-callout-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 800;
  color: #991b1b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}
.kev-callout-row { font-size: 12px; color: #7f1d1d; line-height: 1.5; }
.kev-callout-row strong { color: #450a0a; }
.kev-callout a { color: #b91c1c; font-weight: 600; }

/* Legend swatch for KEV ring in the KG view */
.kg-legend-dot--kev {
  background: #ef4444;
  box-shadow: 0 0 0 2px #fff, 0 0 0 3.5px #b91c1c;
}

/* ── Query page: viewport-fit layout (no page scrollbar; panels scroll) ── */
.query-page {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.query-block--fill {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-top: 12px;
}
.query-results {
  flex: 1 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 3fr);
  gap: 12px;
}
.query-results--single { grid-template-columns: minmax(0, 1fr); }
.query-table-card {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.query-table-card .query-table-scroll {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
}
.query-table-card .query-table-scroll thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f8fafc;
  box-shadow: inset 0 -1px 0 #e5e7eb;
}
.query-graph-card {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* ── Query page: node detail panel (floats over the graph so the canvas
      never resizes — resizing would reset the force-graph camera) ── */
.query-graph-split { position: relative; flex: 1 1; min-height: 180px; }
.query-graph-canvas {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--border);
}
.query-node-panel {
  position: absolute;
  top: 10px;
  right: 10px;
  bottom: 10px;
  width: 300px;
  overflow-y: auto;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 8px;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.12);
  backdrop-filter: blur(4px);
  z-index: 5;
}
.query-node-panel .kg-detail-title { font-size: 14px; }
.query-node-panel dl {
  margin: 0;
  display: grid;
  grid-template-columns: 108px minmax(0, 1fr);
  gap: 7px 10px;
  font-size: 12px;
}
.query-node-panel dt { color: var(--text-secondary); font-weight: 600; overflow-wrap: anywhere; }
.query-node-panel dd { margin: 0; overflow-wrap: anywhere; }
.query-node-open-link {
  display: inline-block;
  margin-top: 12px;
  font-size: 12px;
  font-weight: 600;
  color: var(--accent);
  text-decoration: none;
}
.query-node-open-link:hover { text-decoration: underline; }
.query-node-close {
  float: right;
  border: none;
  background: none;
  font-size: 16px;
  cursor: pointer;
  color: var(--text-secondary);
  padding: 0 2px;
  line-height: 1;
}
.query-node-close:hover { color: var(--text); }

/* ---------- mobile: stack side-by-side panels vertically ---------- */
@media (max-width: 700px) {
  /* Knowledge Graph view: graph on top, details below */
  .kg-layout {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: minmax(320px, 52vh) minmax(0, 1fr);
  }

  /* Ontology view: the data table opens below the graph instead of beside it */
  .ont-split {
    flex-direction: column;
  }
  .ont-split-graph {
    min-height: 300px;
  }
  .ont-split-table.open {
    flex: 0 0 46%;
    margin-left: 0;
    margin-top: 12px;
  }

  /* small canvas: the legend eats too much of the graph — hide it */
  .kg-legend {
    display: none;
  }

  /* search on its own line, chips on a second full-width line */
  .kg-overlay-top {
    flex-direction: column;
    align-items: stretch;
  }
  .kg-search-wrap {
    width: auto;
    margin-right: 56px;
  }

  /* type filters: one compact swipeable row instead of stacking over the graph */
  .kg-type-filters {
    flex-wrap: nowrap;
    justify-content: flex-start;
    overflow-x: auto;
    gap: 6px;
    margin-right: 56px;
    padding-bottom: 2px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .kg-type-filters::-webkit-scrollbar {
    display: none;
  }
  .kg-type-pill {
    flex: 0 0 auto;
    padding: 4px 9px;
    font-size: 11px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,IAAI,SAAS,EAAE,UAAU,EAAE,sBAAsB,EAAE;;AAEnD;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA,OAAO,sEAAsE,EAAE,qBAAqB,EAAE,kBAAkB,EAAE;AAC1H,OAAO,aAAa,EAAE,iBAAiB,EAAE;;AAEzC,6BAA6B;AAC7B;qDACqD;AACrD,eAAe,sBAAsB,EAAE,aAAa,EAAE,aAAa,EAAE,gBAAgB,EAAE;AACvF;EACE,mBAAmB;EACnB,gCAAgC;EAChC,yCAAyC;EACzC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,YAAY;AACZ,WAAW,SAAO,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AAC3D,mBAAmB,kBAAkB,EAAE,eAAe,EAAE,kBAAkB,EAAE,aAAa,EAAE,gBAAgB,EAAE;;AAE7G;;;;wEAIwE;AACxE,sBAAsB,cAAc,EAAE,YAAY,EAAE;AACpD;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA,gBAAgB;AAChB,eAAe,mBAAmB,EAAE;AACpC,kBAAkB,eAAe,EAAE,gBAAgB,EAAE;;AAErD,UAAU;AACV,QAAQ,uBAAuB,EAAE,4BAA4B,EAAE,+BAA+B,EAAE,aAAa,EAAE;AAC/G,WAAW,eAAe,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;;AAEnJ,SAAS;AACT,QAAQ,aAAa,EAAE,MAAM,EAAE,mBAAmB,EAAE,sCAAsC,EAAE;AAC5F,OAAO,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,eAAe,EAAE,YAAY,EAAE,oCAAoC,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAC/N,aAAa,kBAAkB,EAAE;AACjC,cAAc,oBAAoB,EAAE,kCAAkC,EAAE,gBAAgB,EAAE;;AAE1F,WAAW;AACX,cAAc,gBAAgB,EAAE;AAChC,QAAQ,WAAW,EAAE,yBAAyB,EAAE,eAAe,EAAE;AACjE,mBAAmB,iBAAiB,EAAE;AACtC,KAAK,gBAAgB,EAAE,iBAAiB,EAAE,sCAAsC,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,eAAe,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;AAC1N,KAAK,iBAAiB,EAAE,sCAAsC,EAAE;AAChE,WAAW,+BAA+B,EAAE;AAC5C,OAAO,oBAAoB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;AACtE,aAAa,0BAA0B,EAAE;AACzC,iBAAiB,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAEjF,eAAe;AACf,cAAc,aAAa,EAAE,QAAQ,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AACvG;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB,YAAY,mBAAmB,EAAE,aAAa,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAE5I,oBAAoB;AACpB,SAAS,mBAAmB,EAAE,cAAc,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAC5H,WAAW,kBAAkB,EAAE,aAAa,EAAE,4BAA4B,EAAE;;AAE5E,YAAY;AACZ,OAAO,kBAAkB,EAAE,yBAAyB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,mBAAmB,EAAE;AAC9K,aAAa,mBAAmB,EAAE;AAClC,gBAAgB,YAAY,EAAE,mBAAmB,EAAE;;AAEnD,aAAa;AACb,cAAc,mBAAmB,EAAE;AACnC,cAAc,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,eAAe,EAAE,cAAc,EAAE;AAChJ,oBAAoB,kBAAkB,EAAE;AACxC,WAAW,eAAe,EAAE;AAC5B,gBAAgB,aAAa,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC/D,sBAAsB,SAAO,EAAE,kBAAkB,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACzH,4BAA4B,aAAa,EAAE,2BAA2B,EAAE,0CAA0C,EAAE;AACpH,iBAAiB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AAC/E,QAAQ,iBAAiB,EAAE,eAAe,EAAE,+BAA+B,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,eAAe,EAAE,4BAA4B,EAAE;AACpK,cAAc,2BAA2B,EAAE,oBAAoB,EAAE;;AAEjE,gBAAgB;AAChB,eAAe,mBAAmB,EAAE;AACpC,sBAAsB,mBAAmB,EAAE;AAC3C,aAAa,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,kBAAkB,EAAE;AACpK,cAAc,WAAW,EAAE,kBAAkB,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,8CAA8C,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC9O,oBAAoB,aAAa,EAAE,2BAA2B,EAAE,0CAA0C,EAAE;AAC5G,2BAA2B,WAAW,EAAE;AACxC,eAAe,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;AAC/E,QAAQ,eAAe,EAAE,4BAA4B,EAAE;AACvD,eAAe,eAAe,EAAE;;AAEhC,4BAA4B;AAC5B,YAAY,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,uBAAuB,EAAE,4BAA4B,EAAE,eAAe,EAAE,qBAAqB,EAAE;AACtN,kBAAkB,2BAA2B,EAAE,oBAAoB,EAAE;AACrE,mBAAmB,yBAAyB,EAAE,WAAW,EAAE,2BAA2B,EAAE;;AAExF,wBAAwB;AACxB,eAAe,gBAAgB,EAAE;AACjC,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACzF,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;AAC9H,gBAAgB,aAAa,EAAE;;AAE/B,iBAAiB;AACjB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,YAAY,mBAAmB,EAAE,cAAc,EAAE;AACjD,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;;AAEvD,uDAAuD;;AAEvD,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,SAAO;EACP,aAAa;AACf;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8EAA8E;EAC9E,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,wCAAwC;EACxC,kBAAkB;EAClB,4CAA4C;EAC5C,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAO;EACP,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,wCAAwC;EACxC,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4CAA4C;EAC5C,0BAA0B;EAC1B,6DAA6D;AAC/D;AACA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,4CAA4C;EAC5C,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,oCAAoC;EACpC,uCAAuC;EACvC,kBAAkB;EAClB,4CAA4C;EAC5C,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gDAAgD;EAChD,mDAAmD;EACnD,yBAAyB;EACzB,4CAA4C;EAC5C,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,aAAa;EACb,2CAA2C;EAC3C,aAAa;EACb,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;AACjB;AACA,6EAA6E;AAC7E;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;4DAC4D;AAC5D,kBAAkB,kBAAkB,EAAE,SAAO,EAAE,aAAa,EAAE;AAC9D;EACE,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,SAAO;EACP,YAAY;EACZ,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,SAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oDAAoD;EACpD,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,iBAAiB;AACnB;AACA,yEAAyE;AACzE;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,cAAc;EACd,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,gDAAgD;AAClD;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA,yBAAyB,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE;AAC1E;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA,iCAAiC,cAAc,EAAE;AACjD;EACE,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;AACA,kCAAkC,qBAAqB,EAAE,cAAc,EAAE;AACzE;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA,iCAAiC,mBAAmB,EAAE;AACtD;+EAC+E;AAC/E;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;AACA,0BAA0B,qBAAqB,EAAE;AACjD;EACE,aAAa;EACb,QAAQ;AACV;AACA,sCAAsC,YAAY,EAAE;AACpD;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,cAAc;AAChB;AACA,yBAAyB,kBAAkB,EAAE;AAC7C;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,kCAAkC;AACpC;AACA,wEAAwE;;AAExE,4BAA4B;AAC5B;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAO;EACP,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,cAAc;AAChB;AACA,2BAA2B,kBAAkB,EAAE;AAC/C;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,cAAc;EACd,gCAAgC;AAClC;AACA,0BAA0B,mBAAmB,EAAE;AAC/C;EACE,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;AACvB;AACA,oBAAoB,0BAA0B,EAAE;;AAEhD,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,cAAc;AACd;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,SAAO;EACP,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,sDAAsD;AACtD,mBAAmB,gBAAgB,EAAE;AACrC,kBAAkB,mBAAmB,EAAE;AACvC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;AACA,yBAAyB,mBAAmB,EAAE;AAC9C,mBAAmB,SAAO,EAAE,YAAY,EAAE;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA,kBAAkB,SAAO,EAAE,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACzG,mBAAmB,cAAc,EAAE;AACnC,mBAAmB,cAAc,EAAE,eAAe,EAAE;;AAEpD,0EAA0E;AAC1E,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAEvF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA,uBAAuB,eAAe,EAAE,kBAAkB,EAAE;;AAE5D,qBAAqB,kBAAkB,EAAE;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;AACR;AACA,+BAA+B,mBAAmB,EAAE;AACpD,kCAAkC,mBAAmB,EAAE;;AAEvD,0EAA0E;AAC1E;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;AACA,uBAAuB,mBAAmB,EAAE;AAC5C,qBAAqB,gBAAgB,EAAE;AACvC,mBAAmB,mBAAmB,EAAE;AACxC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA,YAAY,cAAc,EAAE,mBAAmB,EAAE;AACjD,eAAe,cAAc,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACrE;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E,uBAAuB,mBAAmB,EAAE;AAC5C,6BAA6B,mBAAmB,EAAE;AAClD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;AACA,mCAAmC,mBAAmB,EAAE;AACxD;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;AACA,gCAAgC,0BAA0B,EAAE;AAC5D;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,0EAA0E;AAC1E,gBAAgB,gBAAgB,EAAE;AAClC;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,UAAU;EACV,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA,sBAAsB,mBAAmB,EAAE;AAC3C;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA,gCAAgC,eAAe,EAAE;AACjD,sCAAsC,gBAAgB,EAAE;;AAExD,8DAA8D;AAC9D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,0BAA0B;EAC1B,oCAAoC;AACtC;AACA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;AACA,wBAAwB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAChE;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA,0DAA0D;AAC1D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA,wBAAwB,cAAc,EAAE;AACxC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA,+BAA+B,cAAc,EAAE;;AAE/C,kEAAkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA,wBAAwB,0BAA0B,EAAE;AACpD;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;AACA,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;AACtD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;AACjB;AACA,mBAAmB,eAAe,EAAE,cAAc,EAAE;AACpD;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA,sCAAsC,cAAc,EAAE;AACtD;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA,+CAA+C,cAAc,EAAE;AAC/D,iDAAiD,cAAc,EAAE;AACjE,gDAAgD,cAAc,EAAE;AAChE,sBAAsB,SAAS,EAAE,UAAU,EAAE,gBAAgB,EAAE;AAC/D,sBAAsB,eAAe,EAAE,cAAc,EAAE,cAAc,EAAE;AACvE,yBAAyB,eAAe,EAAE,cAAc,EAAE;AAC1D;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;AACA,0BAA0B,qBAAqB,EAAE,mBAAmB,EAAE;AACtE,2BAA2B,cAAc,EAAE;AAC3C,iCAAiC,qBAAqB,EAAE,mBAAmB,EAAE;AAC7E;EACE,SAAO;EACP,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,uBAAuB,0BAA0B,EAAE;AACnD;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,8DAA8D;AAC9D;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;AACrB;AACA,gBAAgB,cAAc,EAAE;AAChC;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,+DAA+D;AAC/D;EACE,wCAAwC;EACxC,yEAAyE;AAC3E;AACA,yBAAyB,WAAW,EAAE,eAAe,EAAE;AACvD,oBAAoB,oBAAoB,EAAE;AAC1C,qBAAqB,gBAAgB,EAAE,qBAAqB,EAAE;;AAE9D,qCAAqC;AACrC;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;AACA,8CAA8C,8BAA8B,EAAE;;AAE9E,4EAA4E;AAC5E;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,mDAAmD;AACnD;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,oCAAoC;AACpC;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;AACjD;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA,mBAAmB,SAAO,EAAE,YAAY,EAAE;AAC1C;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;AACA,wBAAwB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACzE;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA,yBAAyB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC5E;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,oCAAoC;AACtC;AACA,yBAAyB,mBAAmB,EAAE,qBAAqB,EAAE;;AAErE,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;AACA,mBAAmB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACtE,0BAA0B,cAAc,EAAE;AAC1C,iBAAiB,cAAc,EAAE,gBAAgB,EAAE;;AAEnD,8CAA8C;AAC9C;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA,6EAA6E;AAC7E;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;AACA,yBAAyB,qCAAqC,EAAE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,SAAO;EACP,aAAa;EACb,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;uEACuE;AACvE,qBAAqB,kBAAkB,EAAE,SAAO,EAAE,iBAAiB,EAAE;AACrE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,6CAA6C;EAC7C,0BAA0B;EAC1B,UAAU;AACZ;AACA,qCAAqC,eAAe,EAAE;AACtD;EACE,SAAS;EACT,aAAa;EACb,2CAA2C;EAC3C,aAAa;EACb,eAAe;AACjB;AACA,uBAAuB,4BAA4B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAChG,uBAAuB,SAAS,EAAE,uBAAuB,EAAE;AAC3D;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;AACA,8BAA8B,0BAA0B,EAAE;AAC1D;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,cAAc;AAChB;AACA,0BAA0B,kBAAkB,EAAE;;AAE9C,uEAAuE;AACvE;EACE,sDAAsD;EACtD;IACE,qCAAqC;IACrC,sDAAsD;EACxD;;EAEA,6EAA6E;EAC7E;IACE,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,cAAc;IACd,gBAAgB;EAClB;;EAEA,kEAAkE;EAClE;IACE,aAAa;EACf;;EAEA,8DAA8D;EAC9D;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA,+EAA+E;EAC/E;IACE,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;IAChB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;IACjC,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":["* { margin: 0; padding: 0; box-sizing: border-box; }\n\n:root {\n  --bg: #f8f9fb;\n  --sidebar: #1a1d23;\n  --sidebar-hover: #2a2d35;\n  --accent: #4f8cff;\n  --accent-light: #e8f0ff;\n  --text: #1a1d23;\n  --text-secondary: #6b7280;\n  --border: #e5e7eb;\n  --card: #ffffff;\n  --radius: 10px;\n}\n\nbody { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; background: var(--bg); color: var(--text); }\n.app { display: flex; min-height: 100vh; }\n\n/* ── Top navigation bar ── */\n/* Fixed-viewport shell: the window itself never scrolls — pages that\n   overflow scroll inside .content--topnav instead. */\n.app--topnav { flex-direction: column; height: 100vh; min-height: 0; overflow: hidden; }\n.topbar {\n  background: #f1f5f9;\n  border-bottom: 1px solid #e2e8f0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  padding: 0 18px;\n  display: flex;\n  align-items: center;\n  height: 48px;\n  flex-shrink: 0;\n}\n.topbar-tabs {\n  display: flex;\n  gap: 8px;\n  height: 100%;\n  align-items: center;\n}\n.topbar-link {\n  color: #64748b;\n  text-decoration: none;\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  transition: all 0.15s ease;\n  letter-spacing: 0.2px;\n}\n.topbar-link:hover {\n  color: #1e293b;\n  background: #e2e8f0;\n  border-color: #cbd5e1;\n}\n.topbar-link.active {\n  color: #1d4ed8;\n  font-weight: 600;\n  background: #ffffff;\n  border-color: #93c5fd;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n/* Content */\n.content { flex: 1; padding: 28px 32px; max-width: 1480px; }\n.content--topnav { padding: 16px 24px; max-width: none; position: relative; min-height: 0; overflow-y: auto; }\n\n/* Keep the Explorer mounted but hidden when another tab is active. Crucially\n   the hidden state must NOT collapse the element's box to 0×0 (that would make\n   ForceGraph2D reset its zoom transform on the way back). Absolute + inset:0\n   keeps the same width/height as the visible state; visibility:hidden keeps\n   layout boxes (so clientWidth/Height stay valid) while hiding paint. */\n.explorer-keepalive { display: block; height: 100%; }\n.explorer-keepalive.hidden {\n  position: absolute;\n  inset: 0;\n  visibility: hidden;\n  pointer-events: none;\n  z-index: -1;\n}\n\n/* Page header */\n.page-header { margin-bottom: 20px; }\n.page-header h1 { font-size: 20px; font-weight: 700; }\n\n/* Cards */\n.card { background: var(--card); border-radius: var(--radius); border: 1px solid var(--border); padding: 20px; }\n.card h3 { font-size: 12px; color: var(--text-secondary); font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 12px; }\n\n/* Tabs */\n.tabs { display: flex; gap: 0; margin-bottom: 20px; border-bottom: 2px solid var(--border); }\n.tab { padding: 10px 20px; font-size: 13px; font-weight: 500; color: var(--text-secondary); cursor: pointer; border: none; border-bottom: 2px solid transparent; margin-bottom: -2px; background: none; transition: all 0.15s; }\n.tab:hover { color: var(--text); }\n.tab.active { color: var(--accent); border-bottom-color: var(--accent); font-weight: 500; }\n\n/* Tables */\n.table-wrap { overflow-x: auto; }\ntable { width: 100%; border-collapse: collapse; font-size: 13px; }\ntable.wide-table { min-width: 1400px; }\nth { text-align: left; padding: 8px 12px; border-bottom: 2px solid var(--border); color: var(--text-secondary); font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px; white-space: nowrap; }\ntd { padding: 8px 12px; border-bottom: 1px solid var(--border); }\ntr:hover { background: var(--accent-light); }\ntd a { color: var(--accent); text-decoration: none; font-weight: 500; }\ntd a:hover { text-decoration: underline; }\n.cell-truncate { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n/* Pagination */\n.pagination { display: flex; gap: 8px; margin-top: 12px; align-items: center; justify-content: center; }\n.pagination {\n  display: flex;\n  gap: 12px;\n  margin-top: 0;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 16px;\n  border-top: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n.pagination button {\n  min-width: 88px;\n  padding: 7px 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #ffffff;\n  cursor: pointer;\n  font-size: 12px;\n  line-height: 1.2;\n  color: #1f2937;\n  transition: all 0.15s ease;\n}\n.pagination button:hover:not(:disabled) {\n  border-color: #93c5fd;\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n.pagination button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  background: #f8fafc;\n}\n.pagination span {\n  font-size: 12px;\n  color: #64748b;\n  min-width: 84px;\n  text-align: center;\n}\n.pagination-jump {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: 8px;\n}\n.pagination-jump-label {\n  font-size: 12px;\n  color: #64748b;\n}\n.pagination-jump-input {\n  width: 64px;\n  padding: 7px 8px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #0f172a;\n  font-size: 12px;\n  line-height: 1.2;\n  text-align: center;\n}\n.pagination-jump-input:focus {\n  outline: none;\n  border-color: #93c5fd;\n  box-shadow: 0 0 0 2px rgba(147, 197, 253, 0.3);\n}\n.pagination-jump-btn {\n  min-width: 52px;\n  padding: 7px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #1f2937;\n  font-size: 12px;\n  line-height: 1.2;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n.pagination-jump-btn:hover {\n  border-color: #93c5fd;\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n/* Description box */\n.desc-box { background: #f9fafb; padding: 16px; border-radius: 8px; font-size: 13px; line-height: 1.6; color: #374151; margin-bottom: 20px; }\n\n/* Error / Loading */\n.error { background: #fef2f2; color: #dc2626; padding: 12px 16px; border-radius: 8px; margin-bottom: 16px; font-size: 13px; }\n.loading { text-align: center; padding: 40px; color: var(--text-secondary); }\n\n/* Buttons */\n.btn { padding: 10px 24px; background: var(--accent); color: #fff; border: none; border-radius: 8px; font-size: 14px; font-weight: 600; cursor: pointer; white-space: nowrap; }\n.btn:hover { background: #3b7aef; }\n.btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* NL → SQL */\n.nl-section { margin-bottom: 20px; }\n.toggle-btn { background: none; border: none; font-size: 14px; font-weight: 600; color: var(--text-secondary); cursor: pointer; padding: 8px 0; }\n.toggle-btn:hover { color: var(--text); }\n.nl-body { margin-top: 8px; }\n.nl-input-row { display: flex; gap: 12px; margin-bottom: 12px; }\n.nl-input-row input { flex: 1; padding: 10px 14px; border: 1px solid var(--border); border-radius: 8px; font-size: 14px; }\n.nl-input-row input:focus { outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px rgba(79,140,255,0.1); }\n.example-chips { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 8px; }\n.chip { padding: 5px 12px; font-size: 12px; border: 1px solid var(--border); border-radius: 16px; background: white; cursor: pointer; color: var(--text-secondary); }\n.chip:hover { border-color: var(--accent); color: var(--accent); }\n\n/* SQL section */\n.sql-section { margin-bottom: 16px; }\n.sql-editor-section { margin-bottom: 20px; }\n.sql-label { display: block; font-size: 12px; font-weight: 600; color: var(--text-secondary); text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 6px; }\n.sql-editor { width: 100%; padding: 14px 16px; border: 1px solid var(--border); border-radius: 8px; font-family: 'SF Mono', 'Fira Code', monospace; font-size: 13px; line-height: 1.6; resize: vertical; background: #1a1d23; color: #e2e8f0; }\n.sql-editor:focus { outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px rgba(79,140,255,0.1); }\n.sql-editor::placeholder { color: #555; }\n.sql-actions { display: flex; align-items: center; gap: 12px; margin-top: 8px; }\n.hint { font-size: 12px; color: var(--text-secondary); }\n.result-card { margin-top: 4px; }\n\n/* View buttons (reusable) */\n.view-btn { padding: 8px 20px; font-size: 13px; font-weight: 600; border: 1px solid var(--border); border-radius: 8px; background: var(--card); color: var(--text-secondary); cursor: pointer; transition: all 0.15s; }\n.view-btn:hover { border-color: var(--accent); color: var(--accent); }\n.view-btn.active { background: var(--accent); color: #fff; border-color: var(--accent); }\n\n/* Query result blocks */\n.query-block { margin-top: 20px; }\n.query-block-header { display: flex; align-items: center; gap: 12px; margin-bottom: 8px; }\n.query-block-label { font-size: 13px; font-weight: 700; color: var(--text); text-transform: uppercase; letter-spacing: 0.5px; }\n.code-toggles { display: none; }\n\n/* ── Badges ── */\n.badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.4;\n  white-space: nowrap;\n}\n.badge-ai { background: #dbeafe; color: #1d4ed8; }\n.badge-non-ai { background: #f3f4f6; color: #6b7280; }\n.badge-threat-1 { background: #fecaca; color: #991b1b; }\n.badge-threat-2 { background: #fef3c7; color: #92400e; }\n.badge-threat-3 { background: #d1fae5; color: #065f46; }\n.badge-threat-4 { background: #f3f4f6; color: #6b7280; }\n\n/* (old graph-and-panel removed — unified layout now) */\n\n/* ── Ontology layout: graph left, table slides in from right ── */\n.explorer-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n.explorer-view-switch {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.kg-placeholder {\n  min-height: calc(100vh - 132px);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  color: var(--text-secondary);\n}\n.kg-placeholder h3 {\n  color: var(--text);\n  margin-bottom: 8px;\n}\n.kg-placeholder p {\n  max-width: 680px;\n  line-height: 1.6;\n}\n.kg-placeholder-muted {\n  margin-top: 8px;\n  font-size: 13px;\n}\n.kg-status-box {\n  margin: 16px 0;\n  padding: 14px 16px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #f8fafc;\n  text-align: left;\n  min-width: 420px;\n  font-size: 13px;\n  line-height: 1.7;\n}\n.kg-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  height: 100%;\n  min-height: 0;\n}\n.kg-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 320px;\n  gap: 12px;\n  flex: 1;\n  min-height: 0;\n}\n.kg-graph-shell {\n  padding: 0;\n  overflow: hidden;\n  min-height: 0;\n}\n.kg-canvas-wrap {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  background: #f8fafc;\n  background-image: radial-gradient(rgba(15, 23, 42, 0.05) 1px, transparent 1px);\n  background-size: 22px 22px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n}\n.kg-overlay {\n  position: absolute;\n  z-index: 4;\n  pointer-events: none;\n}\n.kg-overlay > * {\n  pointer-events: auto;\n}\n.kg-overlay-top {\n  top: 12px;\n  left: 12px;\n  right: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 10px;\n}\n.kg-overlay-bottom {\n  bottom: 12px;\n  left: 12px;\n  right: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.kg-search-wrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 200px;\n  max-width: 280px;\n  padding: 8px 12px;\n  background: rgba(255, 255, 255, 0.92);\n  border: 1px solid rgba(15, 23, 42, 0.12);\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n  backdrop-filter: blur(4px);\n}\n.kg-search-icon {\n  color: #64748b;\n  font-size: 16px;\n}\n.kg-search-inline {\n  flex: 1;\n  border: none;\n  background: transparent;\n  color: #0f172a;\n  font-size: 14px;\n  outline: none;\n  min-width: 0;\n}\n.kg-search-inline::placeholder {\n  color: #94a3b8;\n}\n.kg-type-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex: 1;\n  justify-content: center;\n}\n.kg-type-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid rgba(15, 23, 42, 0.12);\n  background: rgba(255, 255, 255, 0.88);\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n  backdrop-filter: blur(4px);\n  transition: border-color 0.15s, background 0.15s, color 0.15s;\n}\n.kg-type-pill[data-active=\"true\"] {\n  border-color: var(--accent);\n  background: #ffffff;\n  color: #1d4ed8;\n  box-shadow: 0 1px 4px rgba(37, 99, 235, 0.2);\n}\n.kg-type-pill[data-active=\"false\"] {\n  opacity: 0.55;\n}\n.kg-type-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.kg-zoom-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-left: auto;\n}\n.kg-zoom-btn {\n  width: 32px;\n  height: 32px;\n  border: 1px solid rgba(15, 23, 42, 0.12);\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.92);\n  color: #334155;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n  backdrop-filter: blur(4px);\n}\n.kg-zoom-btn[data-active=\"true\"] {\n  border-color: var(--accent);\n  color: #1d4ed8;\n}\n.kg-zoom-btn:hover {\n  background: #ffffff;\n  border-color: rgba(15, 23, 42, 0.2);\n}\n.kg-legend {\n  position: absolute;\n  bottom: 52px;\n  left: 12px;\n  z-index: 4;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 10px 12px;\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(15, 23, 42, 0.1);\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n  backdrop-filter: blur(4px);\n  pointer-events: none;\n}\n.kg-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #475569;\n  text-transform: capitalize;\n}\n.kg-legend-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n.kg-summary-dark {\n  color: #64748b;\n  font-size: 12px;\n  margin-left: auto;\n}\n.kg-action-btn {\n  background: rgba(255, 255, 255, 0.92) !important;\n  border: 1px solid rgba(15, 23, 42, 0.12) !important;\n  color: #334155 !important;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n  backdrop-filter: blur(4px);\n}\n.kg-empty-dark {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #64748b;\n}\n.kg-graph {\n  padding: 0;\n  overflow: hidden;\n  min-height: 0;\n}\n.kg-detail {\n  overflow: auto;\n  min-height: 0;\n  max-height: 100%;\n}\n.kg-detail-title {\n  font-weight: 700;\n  color: var(--text);\n  margin-bottom: 4px;\n  overflow-wrap: anywhere;\n}\n.kg-detail-type {\n  display: inline-block;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: #e0f2fe;\n  color: #0369a1;\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n.kg-detail dl {\n  margin: 0;\n  display: grid;\n  grid-template-columns: 110px minmax(0, 1fr);\n  gap: 8px 10px;\n  font-size: 12px;\n}\n.kg-detail dt {\n  color: var(--text-secondary);\n  font-weight: 600;\n}\n.kg-detail dd {\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n.kg-sources {\n  margin-top: 16px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border);\n}\n.kg-sources-head {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--text);\n  margin-bottom: 8px;\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.kg-sources-hint {\n  font-weight: 400;\n  font-size: 11px;\n  color: var(--text-secondary);\n}\n.kg-sources-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.kg-sources-list li {\n  font-size: 12px;\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n.kg-sources-list a {\n  color: #2563eb;\n  text-decoration: none;\n  overflow-wrap: anywhere;\n}\n.kg-sources-list a:hover {\n  text-decoration: underline;\n}\n.kg-source-via {\n  font-size: 10px;\n  color: var(--text-secondary);\n  background: var(--surface-2, #f1f5f9);\n  padding: 1px 6px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n.kg-empty {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary);\n  font-size: 14px;\n}\n/* Explorer fills the viewport-sized content area exactly — no page scroll. */\n.explorer-root {\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n/* Holds the ontology view (in flow) and the KG view (overlay) so toggling\n   between them never unmounts/resizes either force-graph. */\n.explorer-views { position: relative; flex: 1; min-height: 0; }\n.explorer-kg-layer {\n  position: absolute;\n  inset: 0;\n  background: var(--bg, #f8fafc);\n  z-index: 5;\n}\n.explorer-kg-layer.hidden {\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.ont-split {\n  display: flex;\n  flex-direction: row;\n  gap: 0;\n  align-items: stretch;\n  height: 100%;\n  min-height: 0;\n  position: relative;\n}\n.ont-split-graph {\n  flex: 1;\n  min-width: 0;\n  transition: flex 0.3s ease;\n  contain: layout paint;\n  isolation: isolate;\n  border-radius: var(--radius);\n}\n.ont-split-table {\n  flex: 0 0 0px;\n  min-width: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  transition: flex-basis 0.3s ease, opacity 0.25s ease;\n  opacity: 0;\n  pointer-events: none;\n}\n.ont-split-table.open {\n  flex: 0 0 48%;\n  opacity: 1;\n  pointer-events: auto;\n  margin-left: 12px;\n}\n/* Table-only: hide graph so the data grid uses the full explorer width */\n.ont-split--table-full .ont-split-graph {\n  display: none;\n}\n.ont-split--table-full .ont-split-table.open {\n  flex: 1 1 100%;\n  margin-left: 0;\n  min-width: 0;\n}\n.ont-table-container {\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  max-height: 100%;\n}\n.ont-table-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 20px;\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n.ont-table-search-wrap {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 12px;\n  background: #f8fafc;\n  border: 1px solid #cbd5e1;\n  border-radius: 999px;\n  width: 200px;\n  transition: border-color 0.15s, background 0.15s;\n}\n.ont-table-search-wrap:focus-within {\n  border-color: #93c5fd;\n  background: #ffffff;\n}\n.ont-table-search-icon { color: #94a3b8; font-size: 15px; line-height: 1; }\n.ont-table-search {\n  flex: 1;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 13px;\n  color: #0f172a;\n  min-width: 0;\n}\n.ont-table-search::placeholder { color: #94a3b8; }\n.ont-table-empty {\n  text-align: center;\n  color: #94a3b8;\n  padding: 24px 12px !important;\n  font-size: 13px;\n}\n.ont-table-filters-toggle {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid #cbd5e1;\n  background: #f8fafc;\n  color: #475569;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.15s;\n}\n.ont-table-filters-toggle:hover { border-color: #94a3b8; color: #334155; }\n.ont-table-filters-toggle[data-active=\"true\"] {\n  border-color: #93c5fd;\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n.ont-table-clear-filters {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 6px 10px;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  background: none;\n  color: #dc2626;\n  cursor: pointer;\n}\n.ont-table-clear-filters:hover { background: #fef2f2; }\n/* Per-column filter row. Higher-specificity selector to override the sticky\n   header rule so this row sits directly under the headers (not overlapping). */\n.ont-table-scroll thead tr.ont-filter-row th {\n  padding: 6px 8px;\n  background: #f1f5f9;\n  border-bottom: 1px solid var(--border);\n  box-shadow: none;\n  position: static;\n  z-index: 1;\n}\n.ont-filter-input {\n  width: 100%;\n  min-width: 70px;\n  box-sizing: border-box;\n  padding: 4px 8px;\n  font-size: 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #0f172a;\n  outline: none;\n}\n.ont-filter-input:focus { border-color: #93c5fd; }\n.ont-filter-range {\n  display: flex;\n  gap: 4px;\n}\n.ont-filter-range .ont-filter-input { min-width: 0; }\n.ont-table-expand {\n  font-size: 20px;\n  font-weight: 500;\n  cursor: pointer;\n  color: #475569;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  line-height: 1;\n  border-radius: 999px;\n  border: 1px solid #cbd5e1;\n  background: #f8fafc;\n  transition: all 0.15s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.ont-table-expand:hover {\n  background: #f1f5f9;\n  border-color: #94a3b8;\n  color: #334155;\n}\n.ont-table-expand[data-active=\"true\"] {\n  background: #eff6ff;\n  border-color: #93c5fd;\n  color: #1d4ed8;\n}\n.ont-table-close {\n  margin-left: 0;\n  border: none;\n  background: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  padding: 0 4px;\n  line-height: 1;\n}\n.ont-table-close:hover { color: var(--text); }\n.ont-table-class-name {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1d4ed8;\n}\n.ont-table-count {\n  font-size: 12px;\n  color: var(--text-secondary);\n  background: #f3f4f6;\n  padding: 2px 10px;\n  border-radius: 12px;\n}\n.ont-table-kind-badge {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n.ont-table-kind-badge[data-kind=\"edge\"] {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n.ont-table-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-x: scroll;\n  overflow-y: auto;\n  padding: 0;\n  scrollbar-gutter: stable;\n}\n.ont-table-scroll::-webkit-scrollbar {\n  height: 12px;\n  width: 12px;\n}\n.ont-table-scroll::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 6px;\n}\n.ont-table-scroll::-webkit-scrollbar-thumb {\n  background: #93c5fd;\n  border-radius: 6px;\n  border: 2px solid #f1f5f9;\n}\n.ont-table-scroll::-webkit-scrollbar-thumb:hover {\n  background: #60a5fa;\n}\n.ont-table-scroll table {\n  min-width: max-content;\n  width: 100%;\n}\n.ont-table-scroll thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #f8fafc;\n  box-shadow: inset 0 -1px 0 #e5e7eb;\n}\n/* (table empty state removed — panel is hidden when nothing selected) */\n\n/* ── Node Detail Panel ── */\n.node-detail-panel {\n  width: 300px;\n  min-width: 280px;\n  max-height: 520px;\n  overflow-y: auto;\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 16px;\n}\n.node-detail-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n.node-detail-class-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 700;\n  color: #fff;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.node-detail-label {\n  font-weight: 600;\n  font-size: 14px;\n  flex: 1;\n  word-break: break-word;\n}\n.node-detail-close {\n  border: none;\n  background: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  padding: 0 4px;\n  line-height: 1;\n}\n.node-detail-close:hover { color: var(--text); }\n.node-detail-section-title {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-secondary);\n  margin-bottom: 8px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid var(--border);\n}\n.node-detail-props {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.node-detail-row {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n.node-detail-key {\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n.node-detail-val {\n  font-size: 13px;\n  color: var(--text);\n  word-break: break-word;\n  line-height: 1.4;\n}\n.node-detail-empty {\n  font-size: 13px;\n  color: var(--text-secondary);\n  padding: 12px 0;\n}\n.node-detail-hint {\n  margin-top: 12px;\n  padding-top: 8px;\n  border-top: 1px solid var(--border);\n  font-size: 11px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n\n/* ── Vuln Detail meta bar ── */\n.vuln-meta-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  align-items: center;\n  margin-bottom: 16px;\n  padding: 12px 16px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n}\n.vuln-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.vuln-meta-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n.vuln-meta-value {\n  font-size: 13px;\n  color: var(--text);\n}\n\n/* ── Reference list ── */\n.ref-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.ref-list li {\n  padding: 4px 0;\n  border-bottom: 1px solid #f3f4f6;\n}\n.ref-list li:last-child { border-bottom: none; }\n.ref-list a {\n  color: var(--accent);\n  text-decoration: none;\n  font-size: 13px;\n  word-break: break-all;\n}\n.ref-list a:hover { text-decoration: underline; }\n\n/* ── Extract Page ── */\n.extract-page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.extract-input-card h3 {\n  margin-bottom: 4px;\n}\n.extract-subtitle {\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin-bottom: 16px;\n  line-height: 1.5;\n}\n.extract-url-row {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n.extract-url-input {\n  flex: 1;\n  padding: 10px 14px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: 'SF Mono', 'Fira Code', monospace;\n}\n.extract-url-input:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(79,140,255,0.1);\n}\n.extract-preview-btn {\n  background: #fff !important;\n  color: var(--accent) !important;\n  border: 1px solid var(--accent) !important;\n}\n.extract-preview-btn:hover:not(:disabled) {\n  background: var(--accent-light) !important;\n}\n.extract-options {\n  margin-bottom: 12px;\n}\n.extract-checkbox {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n.extract-checkbox input[type=\"checkbox\"] {\n  accent-color: var(--accent);\n}\n\n/* Pipeline steps */\n.extract-progress-card {\n  padding: 16px 24px;\n}\n.extract-steps {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  justify-content: center;\n}\n.extract-step {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 16px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n.extract-step--pending {\n  color: #9ca3af;\n}\n.extract-step--active {\n  color: #1d4ed8;\n  background: #eff6ff;\n}\n.extract-step--done {\n  color: #059669;\n  background: #ecfdf5;\n}\n.extract-step--error {\n  color: #dc2626;\n  background: #fef2f2;\n}\n.extract-step--skipped {\n  color: #9ca3af;\n  background: #f3f4f6;\n}\n.extract-step-icon {\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n}\n.extract-step-divider {\n  width: 32px;\n  height: 2px;\n  background: #e5e7eb;\n  margin: 0 4px;\n}\n.extract-spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid #93c5fd;\n  border-top-color: #1d4ed8;\n  border-radius: 50%;\n  animation: extract-spin 0.7s linear infinite;\n}\n@keyframes extract-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Stats bar */\n.extract-stats-card {\n  padding: 16px 24px;\n}\n.extract-stats-grid {\n  display: flex;\n  gap: 32px;\n  flex-wrap: wrap;\n}\n.extract-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n}\n.extract-stat-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--accent);\n}\n.extract-stat-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Markdown preview */\n.extract-markdown-preview {\n  margin-top: 12px;\n  padding: 16px;\n  background: #1a1d23;\n  color: #e2e8f0;\n  border-radius: 8px;\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  font-size: 12px;\n  line-height: 1.6;\n  max-height: 400px;\n  overflow: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n/* Vuln list */\n.extract-vuln-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 12px;\n}\n.extract-vuln-card {\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  overflow: hidden;\n}\n.extract-vuln-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  background: #f8fafc;\n  cursor: pointer;\n  flex-wrap: wrap;\n}\n.extract-vuln-header:hover {\n  background: #f1f5f9;\n}\n.extract-vuln-id {\n  font-weight: 700;\n  font-size: 14px;\n}\n.extract-vuln-id a {\n  color: var(--accent);\n  text-decoration: none;\n}\n.extract-vuln-id a:hover {\n  text-decoration: underline;\n}\n.extract-vuln-title {\n  flex: 1;\n  font-size: 13px;\n  color: var(--text-secondary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.extract-vuln-toggle {\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n.extract-vuln-body {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.extract-vuln-desc {\n  font-size: 13px;\n  line-height: 1.6;\n  color: #374151;\n  background: #f9fafb;\n  padding: 12px;\n  border-radius: 6px;\n}\n.extract-vuln-meta {\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n.extract-vuln-meta-label {\n  font-weight: 600;\n  color: #475569;\n}\n.extract-vuln-section {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.extract-vuln-section-title {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-secondary);\n}\n.extract-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n.extract-tag {\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  background: #fef3c7;\n  color: #92400e;\n}\n.extract-products-table {\n  font-size: 12px;\n}\n.extract-products-table th {\n  font-size: 10px;\n  padding: 6px 10px;\n}\n.extract-products-table td {\n  padding: 6px 10px;\n  font-size: 12px;\n}\n\n/* ── Data Sources section (unified with Extract) ── */\n.sources-section { margin-top: 18px; }\n.sources-header { margin-bottom: 12px; }\n.sources-toast {\n  padding: 10px 14px;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 6px;\n  font-size: 13px;\n  margin-bottom: 12px;\n  color: #1e3a8a;\n}\n.sources-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  border-top: 1px solid #e5e7eb;\n}\n.source-row {\n  border-bottom: 1px solid #e5e7eb;\n}\n.source-row-main {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 4px;\n  cursor: pointer;\n}\n.source-row-main:hover { background: #f8fafc; }\n.source-row-info { flex: 1; min-width: 0; }\n.source-row-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.source-row-chevron {\n  color: #94a3b8;\n  font-size: 12px;\n  width: 14px;\n  display: inline-block;\n}\n.source-row-name {\n  font-weight: 600;\n  font-size: 15px;\n  color: #111827;\n}\n.source-row-category {\n  font-size: 11px;\n  color: #64748b;\n  background: #f1f5f9;\n  padding: 2px 8px;\n  border-radius: 9999px;\n}\n.source-row-meta {\n  margin-top: 4px;\n  margin-left: 22px;\n  font-size: 12px;\n  color: #64748b;\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n.btn-primary {\n  background: var(--accent) !important;\n  color: #fff !important;\n  border: none;\n  padding: 8px 16px;\n  font-size: 13px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.btn-primary:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n.source-row-detail {\n  padding: 4px 4px 16px 22px;\n  background: #fafbfc;\n  border-top: 1px solid #f1f5f9;\n}\n.source-url-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  margin-top: 10px;\n}\n.source-url-table th,\n.source-url-table td {\n  padding: 6px 10px;\n  text-align: left;\n  border-bottom: 1px solid #f1f5f9;\n}\n.source-url-table th {\n  font-size: 11px;\n  color: #475569;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  background: #f8fafc;\n}\n.source-url-cell {\n  word-break: break-all;\n  max-width: 500px;\n}\n.source-runs {\n  margin-top: 16px;\n}\n.source-runs-title {\n  font-size: 11px;\n  color: #475569;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  margin-bottom: 6px;\n}\n.source-runs ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.source-runs li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 0;\n  font-size: 12px;\n  color: #475569;\n}\n.source-run-url { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.source-run-meta { color: #64748b; }\n.source-run-time { color: #94a3b8; font-size: 11px; }\n\n/* ── Live extract status + entity tables ────────────────────────────── */\n.extract-results { display: flex; flex-direction: column; gap: 14px; margin-top: 14px; }\n\n.extract-running-banner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 8px;\n  color: #1e3a8a;\n  font-size: 14px;\n  margin-bottom: 12px;\n}\n.extract-running-banner em {\n  font-style: normal;\n  font-weight: 600;\n  color: #1d4ed8;\n}\n\n.extract-warnings {\n  background: #fffbeb;\n  border: 1px solid #fcd34d;\n  color: #92400e;\n  font-size: 13px;\n  padding: 10px 14px;\n}\n.extract-warnings ul { margin: 6px 0 0; padding-left: 20px; }\n\n.entity-table-card { padding: 14px 18px; }\n.entity-table-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n.entity-table-header h4 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n  text-transform: none;\n  letter-spacing: 0;\n}\n.entity-table-wrap {\n  overflow-x: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n}\n.entity-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n.entity-table th,\n.entity-table td {\n  padding: 7px 10px;\n  text-align: left;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: top;\n  white-space: nowrap;\n}\n.entity-table th {\n  font-size: 10.5px;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: #475569;\n  font-weight: 700;\n  background: #f8fafc;\n  position: sticky;\n  top: 0;\n}\n.entity-table tbody tr:hover { background: #f8fafc; }\n.entity-table tr.row-partial td { background: #fffbeb; }\n\n/* ── Running runs panel ─────────────────────────────────────────────── */\n.runs-panel {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: #f8fafc;\n  margin-bottom: 14px;\n  overflow: hidden;\n}\n.runs-panel--active {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  box-shadow: 0 0 0 1px #bfdbfe40;\n}\n.runs-panel-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  font-size: 13px;\n  color: #1e3a8a;\n  border-bottom: 1px solid #e5e7eb;\n  background: rgba(255, 255, 255, 0.5);\n}\n.runs-panel-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-height: 220px;\n  overflow-y: auto;\n}\n.run-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 14px;\n  font-size: 12px;\n  color: #334155;\n  border-bottom: 1px solid #f1f5f9;\n}\n.run-item:last-child { border-bottom: none; }\n.run-item--running { background: #fff; }\n.run-item--error { background: #fef2f2; }\n.run-source {\n  font-weight: 600;\n  min-width: 120px;\n  color: #1e293b;\n}\n.run-url {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #64748b;\n}\n.run-meta { color: #64748b; white-space: nowrap; }\n.run-elapsed { color: #94a3b8; white-space: nowrap; font-size: 11px; }\n.btn-inline {\n  padding: 4px 10px;\n  font-size: 12px;\n  border-radius: 6px;\n  line-height: 1.2;\n}\n.btn-danger {\n  background: #ef4444 !important;\n  color: #fff !important;\n  border: none;\n}\n.btn-danger:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ── Source row: running state ──────────────────────────────────────── */\n.source-row--running { background: #eff6ff; }\n.source-row--running:hover { background: #dbeafe; }\n.source-running-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 10px;\n  background: #dbeafe;\n  color: #1e3a8a;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n  margin-left: 4px;\n}\n.source-running-chip .extract-spinner {\n  width: 10px;\n  height: 10px;\n  border-width: 1.5px;\n}\n\n/* ── Simplified source URL list ─────────────────────────────────────── */\n.source-url-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.source-url-list-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 0;\n  font-size: 13px;\n  border-bottom: 1px solid #f1f5f9;\n}\n.source-url-list-item:last-child { border-bottom: none; }\n.source-url-list-item a {\n  color: #1d4ed8;\n  text-decoration: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n  min-width: 0;\n}\n.source-url-list-item a:hover { text-decoration: underline; }\n.status-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n/* ── Flat URL list (primary UI) ─────────────────────────────────────── */\n.urls-section { margin-top: 18px; }\n.urls-actions {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n  align-items: center;\n}\n.urls-filter {\n  flex: 0 0 180px;\n  padding: 8px 10px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  font-size: 13px;\n}\n.url-flat-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  border-top: 1px solid #f1f5f9;\n}\n.url-flat-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 0;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 13px;\n}\n.url-flat-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 6px;\n}\n.url-flat-row:hover { background: #f8fafc; }\n.url-flat-item--open > .url-flat-row {\n  background: #f1f5f9;\n}\n.url-preview {\n  padding: 10px 12px 14px;\n  background: #f8fafc;\n  border-top: 1px dashed #e2e8f0;\n}\n.url-preview-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #475569;\n  font-size: 13px;\n  padding: 6px 0;\n}\n.url-preview-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 10px;\n  color: #0f172a;\n  font-size: 13px;\n}\n.url-preview-actions {\n  display: flex;\n  gap: 6px;\n}\n.url-preview .extract-results { margin-top: 4px; }\n.url-preview .extract-results .card { box-shadow: none; }\n\n/* ── In-app confirmation modal (replaces window.confirm) ── */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(2px);\n  animation: modal-fade 0.12s ease-out;\n}\n.modal-card {\n  width: min(440px, calc(100vw - 32px));\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.3);\n  padding: 20px 22px 16px;\n  animation: modal-pop 0.14s ease-out;\n}\n.modal-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 8px;\n}\n.modal-body {\n  font-size: 13px;\n  line-height: 1.55;\n  color: #475569;\n  margin-bottom: 18px;\n}\n.confirm-mono {\n  display: block;\n  margin-top: 8px;\n  padding: 8px 10px;\n  background: #f1f5f9;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #334155;\n  word-break: break-all;\n}\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n@keyframes modal-fade { from { opacity: 0; } to { opacity: 1; } }\n@keyframes modal-pop {\n  from { opacity: 0; transform: translateY(6px) scale(0.98); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n/* ── Consolidation summary (shown after Consolidate) ── */\n.consolidate-summary {\n  border: 1px solid #bbf7d0;\n  background: #f0fdf4;\n  border-radius: 10px;\n  padding: 12px 14px;\n  margin-bottom: 12px;\n}\n.consolidate-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 700;\n  font-size: 13px;\n  color: #166534;\n  margin-bottom: 10px;\n}\n.consolidate-head svg { color: #16a34a; }\n.consolidate-headline {\n  font-size: 13px;\n  line-height: 1.5;\n  color: #334155;\n  margin-bottom: 12px;\n}\n.consolidate-headline strong { color: #0f172a; }\n\n/* New/updated vulnerability cards — the payoff of consolidation */\n.consolidate-vulns {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n.vuln-result-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-left: 3px solid #16a34a;\n  border-radius: 8px;\n  padding: 10px 12px;\n}\n.vuln-result-top {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n.vuln-result-id {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 13px;\n  font-weight: 700;\n  color: #1d4ed8;\n  text-decoration: none;\n}\n.vuln-result-id:hover { text-decoration: underline; }\n.vuln-tag {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  padding: 2px 7px;\n  border-radius: 999px;\n}\n.vuln-tag--new { background: #dcfce7; color: #15803d; }\n.vuln-tag--reused { background: #f1f5f9; color: #64748b; }\n.vuln-tag--minted { background: #f3e8ff; color: #7c3aed; }\n.vuln-result-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f172a;\n  margin-top: 5px;\n  line-height: 1.4;\n}\n.vuln-result-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 16px;\n  margin-top: 6px;\n}\n.vuln-result-rel { font-size: 12px; color: #334155; }\n.vuln-result-rel-label {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #94a3b8;\n  margin-right: 4px;\n}\n.vuln-result-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 9px;\n}\n\n.consolidate-breakdown-toggle {\n  background: none;\n  border: none;\n  padding: 4px 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  cursor: pointer;\n}\n.consolidate-breakdown-toggle:hover { color: #334155; }\n.consolidate-cols {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n  margin-top: 8px;\n}\n.consolidate-col {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 8px 10px;\n}\n.consolidate-col-title {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  margin-bottom: 6px;\n  color: #64748b;\n}\n.consolidate-col--add .consolidate-col-title { color: #15803d; }\n.consolidate-col--reuse .consolidate-col-title { color: #1d4ed8; }\n.consolidate-col--link .consolidate-col-title { color: #7c3aed; }\n.consolidate-col ul { margin: 0; padding: 0; list-style: none; }\n.consolidate-col li { font-size: 12px; color: #334155; padding: 2px 0; }\n.consolidate-col-empty { font-size: 12px; color: #cbd5e1; }\n.consolidate-count {\n  display: inline-block;\n  min-width: 18px;\n  font-weight: 700;\n  color: #0f172a;\n}\n.consolidate-note {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #475569;\n}\n.consolidate-where {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px dashed #d1fae5;\n}\n.consolidate-where-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n}\n.consolidate-link {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 3px 10px;\n  border-radius: 999px;\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  color: #1d4ed8;\n  text-decoration: none;\n}\n.consolidate-link:hover { border-color: #1d4ed8; background: #eff6ff; }\n.consolidate-link--graph { color: #7c3aed; }\n.consolidate-link--graph:hover { border-color: #7c3aed; background: #f5f3ff; }\n.url-flat-link {\n  flex: 1;\n  min-width: 0;\n  color: #1d4ed8;\n  text-decoration: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.url-flat-link:hover { text-decoration: underline; }\n.url-flat-entities {\n  color: #64748b;\n  font-size: 11px;\n  background: #f1f5f9;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  white-space: nowrap;\n}\n.url-flat-error {\n  color: #b91c1c;\n  font-size: 11px;\n  max-width: 200px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.url-flat-time {\n  color: #94a3b8;\n  font-size: 11px;\n  white-space: nowrap;\n}\n.btn-ghost {\n  background: transparent !important;\n  color: #94a3b8 !important;\n  border: 1px solid #e5e7eb !important;\n}\n.btn-ghost:hover {\n  color: #ef4444 !important;\n  border-color: #fecaca !important;\n}\n\n/* Small icon + label buttons used inside the URL list rows. */\n.btn-icon {\n  display: inline-flex !important;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px !important;\n  font-size: 12px !important;\n  line-height: 1 !important;\n  border-radius: 9999px !important;\n  white-space: nowrap;\n}\n.btn-icon svg { display: block; }\n.btn-icon.btn-ghost {\n  padding: 4px 6px !important;\n  color: #94a3b8 !important;\n}\n\n/* Smart extract button — variants convey status at a glance. */\n.btn-extract {\n  border: 1px solid transparent !important;\n  transition: background .12s ease, color .12s ease, border-color .12s ease;\n}\n.btn-extract[disabled] { opacity: .7; cursor: default; }\n.btn-extract-icon { display: inline-flex; }\n.btn-extract-label { font-weight: 600; letter-spacing: .01em; }\n\n/* never / default → primary action */\n.btn-extract--extract {\n  background: #4f8cff !important;\n  color: #fff !important;\n}\n.btn-extract--extract:hover:not([disabled]) { background: #3b75ea !important; }\n\n/* fresh → \"done\" pill, subdued but still actionable (click to re-preview) */\n.btn-extract--done {\n  background: #ecfdf5 !important;\n  color: #047857 !important;\n  border-color: #a7f3d0 !important;\n}\n.btn-extract--done:hover:not([disabled]) {\n  background: #d1fae5 !important;\n  border-color: #6ee7b7 !important;\n}\n\n/* merged → stronger success state than extracted */\n.btn-extract--merged {\n  background: #dcfce7 !important;\n  color: #166534 !important;\n  border-color: #86efac !important;\n}\n.btn-extract--merged:hover:not([disabled]) {\n  background: #bbf7d0 !important;\n  border-color: #4ade80 !important;\n}\n\n/* stale / error → amber/red retry */\n.btn-extract--retry {\n  background: #fff7ed !important;\n  color: #b45309 !important;\n  border-color: #fed7aa !important;\n}\n.btn-extract--retry:hover:not([disabled]) {\n  background: #ffedd5 !important;\n  border-color: #fdba74 !important;\n}\n\n/* open preview → close */\n.btn-extract--close {\n  background: #f1f5f9 !important;\n  color: #475569 !important;\n  border-color: #cbd5e1 !important;\n}\n.btn-extract--close:hover:not([disabled]) {\n  background: #e2e8f0 !important;\n}\n\n/* running in background */\n.btn-extract--running {\n  background: #eff6ff !important;\n  color: #1d4ed8 !important;\n  border-color: #bfdbfe !important;\n}\n\n/* ── CISA KEV (Known Exploited Vulnerability) indicators ── */\n.badge-kev {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  background: #7f1d1d;\n  color: #fff;\n  border: 1px solid #991b1b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.badge-kev::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #fca5a5;\n  box-shadow: 0 0 0 2px rgba(252, 165, 165, 0.35);\n}\n.badge-ransomware {\n  background: #431407;\n  color: #fdba74;\n  border: 1px solid #7c2d12;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Full-width advisory banner (vulnerability detail page) */\n.kev-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 14px 18px;\n  margin-bottom: 16px;\n  background: linear-gradient(135deg, #fef2f2 0%, #fff1f2 100%);\n  border: 1px solid #fecaca;\n  border-left: 4px solid #b91c1c;\n  border-radius: 8px;\n}\n.kev-banner-icon {\n  flex-shrink: 0;\n  width: 34px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: #b91c1c;\n  color: #fff;\n  font-size: 17px;\n  font-weight: 700;\n}\n.kev-banner-body { flex: 1; min-width: 0; }\n.kev-banner-title {\n  font-size: 13px;\n  font-weight: 800;\n  color: #7f1d1d;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  margin-bottom: 3px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.kev-banner-text {\n  font-size: 13px;\n  line-height: 1.55;\n  color: #7f1d1d;\n}\n.kev-banner-meta {\n  display: flex;\n  gap: 18px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n}\n.kev-banner-meta-item { display: flex; flex-direction: column; gap: 1px; }\n.kev-banner-meta-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: #b91c1c;\n}\n.kev-banner-meta-value { font-size: 13px; font-weight: 600; color: #450a0a; }\n.kev-banner-link {\n  font-size: 12px;\n  font-weight: 600;\n  color: #b91c1c;\n  text-decoration: none;\n  white-space: nowrap;\n  align-self: center;\n  padding: 6px 12px;\n  border: 1px solid #fca5a5;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.7);\n}\n.kev-banner-link:hover { background: #fee2e2; border-color: #f87171; }\n\n/* Compact callout (graph detail side panels) */\n.kev-callout {\n  margin: 0 0 12px;\n  padding: 10px 12px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-left: 3px solid #b91c1c;\n  border-radius: 6px;\n}\n.kev-callout-title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 800;\n  color: #991b1b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 4px;\n}\n.kev-callout-row { font-size: 12px; color: #7f1d1d; line-height: 1.5; }\n.kev-callout-row strong { color: #450a0a; }\n.kev-callout a { color: #b91c1c; font-weight: 600; }\n\n/* Legend swatch for KEV ring in the KG view */\n.kg-legend-dot--kev {\n  background: #ef4444;\n  box-shadow: 0 0 0 2px #fff, 0 0 0 3.5px #b91c1c;\n}\n\n/* ── Query page: viewport-fit layout (no page scrollbar; panels scroll) ── */\n.query-page {\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n.query-block--fill {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  margin-top: 12px;\n}\n.query-results {\n  flex: 1;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(0, 3fr);\n  gap: 12px;\n}\n.query-results--single { grid-template-columns: minmax(0, 1fr); }\n.query-table-card {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n.query-table-card .query-table-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n}\n.query-table-card .query-table-scroll thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #f8fafc;\n  box-shadow: inset 0 -1px 0 #e5e7eb;\n}\n.query-graph-card {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n/* ── Query page: node detail panel (floats over the graph so the canvas\n      never resizes — resizing would reset the force-graph camera) ── */\n.query-graph-split { position: relative; flex: 1; min-height: 180px; }\n.query-graph-canvas {\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid var(--border);\n}\n.query-node-panel {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  bottom: 10px;\n  width: 300px;\n  overflow-y: auto;\n  border: 1px solid rgba(15, 23, 42, 0.12);\n  border-radius: 8px;\n  padding: 14px 16px;\n  background: rgba(255, 255, 255, 0.96);\n  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.12);\n  backdrop-filter: blur(4px);\n  z-index: 5;\n}\n.query-node-panel .kg-detail-title { font-size: 14px; }\n.query-node-panel dl {\n  margin: 0;\n  display: grid;\n  grid-template-columns: 108px minmax(0, 1fr);\n  gap: 7px 10px;\n  font-size: 12px;\n}\n.query-node-panel dt { color: var(--text-secondary); font-weight: 600; overflow-wrap: anywhere; }\n.query-node-panel dd { margin: 0; overflow-wrap: anywhere; }\n.query-node-open-link {\n  display: inline-block;\n  margin-top: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--accent);\n  text-decoration: none;\n}\n.query-node-open-link:hover { text-decoration: underline; }\n.query-node-close {\n  float: right;\n  border: none;\n  background: none;\n  font-size: 16px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  padding: 0 2px;\n  line-height: 1;\n}\n.query-node-close:hover { color: var(--text); }\n\n/* ---------- mobile: stack side-by-side panels vertically ---------- */\n@media (max-width: 700px) {\n  /* Knowledge Graph view: graph on top, details below */\n  .kg-layout {\n    grid-template-columns: minmax(0, 1fr);\n    grid-template-rows: minmax(320px, 52vh) minmax(0, 1fr);\n  }\n\n  /* Ontology view: the data table opens below the graph instead of beside it */\n  .ont-split {\n    flex-direction: column;\n  }\n  .ont-split-graph {\n    min-height: 300px;\n  }\n  .ont-split-table.open {\n    flex: 0 0 46%;\n    margin-left: 0;\n    margin-top: 12px;\n  }\n\n  /* small canvas: the legend eats too much of the graph — hide it */\n  .kg-legend {\n    display: none;\n  }\n\n  /* search on its own line, chips on a second full-width line */\n  .kg-overlay-top {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .kg-search-wrap {\n    width: auto;\n    margin-right: 56px;\n  }\n\n  /* type filters: one compact swipeable row instead of stacking over the graph */\n  .kg-type-filters {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    overflow-x: auto;\n    gap: 6px;\n    margin-right: 56px;\n    padding-bottom: 2px;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n  }\n  .kg-type-filters::-webkit-scrollbar {\n    display: none;\n  }\n  .kg-type-pill {\n    flex: 0 0 auto;\n    padding: 4px 9px;\n    font-size: 11px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
